import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import QuotationService from "../../Controller/QuotationController";
import CountryService from "../../../Setup/controller/CountryController/CountryController";
import { handleChange, handleSubmit } from "../../Controller/UpdateOtherInformationController";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import HelpSite from "../../../Common/HelpLink";
import { quillModules, quillFormats, addToolbarTitles } from "../../../Common/quillConfig";
import SunTextEditor from "../../../Common/SunTextEditor";
function QuotationBillingAddress({ QuotationID }) {
    const navigate = useNavigate();
    const location = useLocation();
    const [errors, setErrors] = useState({});
    const [CountryList, setCountries] = useState([]);
    const [formData, setFormData] = useState({
        vc_Notes: "",
        vc_User1: "",
        vc_User2: ""

    });
    const [isClosed, SetIsClosed] = useState("0");
    const { theme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme === "dark") {
        accordTheme = "accordion-header-dark";
    }

    useEffect(() => {
        SetIsClosed("0");
        fetchCountries();
        if (QuotationID > 0) {
            fetchQuotationDetail();
        }
        else {
            resetForm();
        }
    }, [QuotationID]);
    const fetchCountries = async () => {
        try {
            const listOfCountries = await CountryService.GetAllCountries();
            setCountries(listOfCountries);
        } catch (error) {
            console.error('Error fetching countries:', error);
        }
    };
    const fetchQuotationDetail = async () => {
        try {
            const redirectCallback = () => navigate('/');

            if (QuotationID > 0) {
                const quotationDetail = await QuotationService.GetQuotationByID(redirectCallback, QuotationID);
                const quotation = quotationDetail[0];
                setFormData({
                    ...quotation,
                });
                if (quotation.FK_Issue_ID > 0 || quotation.FK_SalesOrder_ID > 0) {
                    SetIsClosed("1");
                }
            }
        } catch (error) {
            console.error('Error fetching agreement details:', error);
        }
    };
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const handleFormSubmit = async (event) => {
        event.preventDefault();

        try {
            const redirectUserList = () => {
                navigate('/QuotationsList?saved=true');
            };
            const message = await handleSubmit(event, formData, setFormData, setErrors);
            if (message == "Data saved successfully") {
                setShowSuccessMessage(true);
                window.scrollTo({ top: 0, behavior: 'smooth' });
                setTimeout(() => {
                    setShowSuccessMessage(false);
                }, 5000);
            }
            else {
                setShowErrorMessage(true);
                window.scrollTo({ top: 0, behavior: 'smooth' });
                setTimeout(() => {
                    setShowErrorMessage(false);
                }, 5000);

            }
            fetchQuotationDetail();
        } catch (error) {
            console.error('Error submitting form:', error);
            setErrors({ submit: 'An error occurred while submitting the form. Please try again.' });
        }
    };
    const handleFieldChange = (event) => {
        handleChange(event, formData, setFormData);
    };
    const resetForm = () => {

        setFormData({
            vc_Notes: "",
            vc_User1: "",
            vc_User2: ""
        });
    };
    const handleEditorChange = (content) => {
        setFormData({
            ...formData,
            vc_Notes: content
        });
    };

    const HelpLink = localStorage.getItem('HelpLink');
    return (
        <div>
            {showSuccessMessage && (
                <div class="alert alert-success bg-success text-light border-0 alert-dismissible fade show" role="alert">
                    Data saved successfully.
                </div>
            )}
            {showErrorMessage && (
                <div class="alert alert-danger bg-danger text-light border-0 alert-dismissible fade show" role="alert">
                    Validation Error.

                </div>
            )}
            <div className="row mb-3" style={{ "marginLeft": "0px" }}>
                <div className="col-xl-12" style={{ "textAlign": "right" }}>

                </div>
            </div>
            <form onSubmit={handleFormSubmit}>
                <div className="row mb-3" style={{ marginRight: "5px", marginTop: "10px" }}>
                    <table style={{ width: "100%" }}>
                        <tbody>
                            <tr>
                                <td> <label htmlFor="vc_Notes" style={{ float: "right" }}>Notes &nbsp;&nbsp;</label></td>
                                <td colSpan={3}>
                                    <SunTextEditor
                                        value={formData.vc_Notes}
                                        onChange={(content) =>
                                            setFormData((prev) => ({
                                                ...prev,
                                                vc_Notes: content,
                                            }))
                                        }
                                    />

                                    {errors.vc_Notes && <div style={{ color: 'red' }}>{errors.vc_Notes}</div>}
                                </td>
                            </tr>
                            <tr>
                                <td style={{width:"13%"}}> <label htmlFor="vc_User1" style={{ float: "right" }}>Order Source <span style={{ "color": "red" }}>*</span></label></td>
                                <td style={{width:"37%"}}>
                                    <select name="vc_User1" className='form-control' value={formData.vc_User1} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1}>
                                        <option value="0">Select Order Source</option>
                                        <option value="Telephone">Telephone</option>
                                        <option value="Post">Post</option>
                                        <option value="Email">Email</option>
                                        <option value="Website">Website</option>
                                    </select>
                                    {errors.vc_User1 && <div style={{ color: 'red' }}>{errors.vc_User1}</div>}
                                </td>
                                <td style={{width:"13%"}}> <label htmlFor="vc_User2" style={{ float: "right" }}>Information Source <span style={{ "color": "red" }}>*</span></label></td>
                                <td style={{width:"37%"}}>
                                    <select name="vc_User2" className='form-control' value={formData.vc_User2} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1}>
                                        <option value="0">Select Information Source</option>
                                        <option value="Web">Web</option>
                                        <option value="Local Newspaper">Local Newspaper</option>
                                        <option value="Existing Customer">Existing Customer</option>
                                        <option value="Other">Other</option>
                                        <option value="Word of Mouth">Word of Mouth</option>
                                        <option value="Roadshow">Roadshow</option>
                                        <option value="Local Radio">Local Radio</option>
                                    </select>
                                    {errors.vc_User2 && <div style={{ color: 'red' }}>{errors.vc_User2}</div>}
                                </td>

                            </tr>
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td style={{ float: "right" }}>
                                    <button type="submit" className="btn btn-primary" disabled={isClosed === '1' || isClosed === 1 || localStorage.getItem('LicenseExpired') == "1"}>
                                        <img src="assets/img/resources/update-icon.png" alt="Add icon" style={{ height: "10px" }} /> Save

                                    </button>

                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </form>


        </div>


    );
}
export default QuotationBillingAddress;

